import type { CheckboxConfig } from '#types/config/components/vf/checkbox'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      variant: {
        base: {
          selected: 'bg-brand-1 ring-brand-1 c-white'
        },
        inverse: {
          selected: 'bg-white ring-white c-grey-10'
        }
      }
    },
    label: {
      size: {
        md: 'subtitle-5',
        sm: 'subtitle-5'
      }
    }
  }
} satisfies RecursivePartial<CheckboxConfig>
